// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingDots__root--1w9z0","dot":"LoadingDots__dot--1B_mw","blink":"LoadingDots__blink--3-rW0"};